"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import gql from "graphql-tag";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";
import type { AccommodationForm } from "./useCreateAccommodationForm";

type AccommodationFormStatus = "DRAFT" | "SIGNED" | "SUBMITTED";

interface UpdateAccommodationFormStatusMutationVariables {
  id: string;
  status: AccommodationFormStatus;
}

export const updateAccommodationFormStatusMutation = gql`
  mutation updateAccommodationFormStatus($id: ID!, $status: AccommodationFormStatus!) {
    updateAccommodationFormStatus(id: $id, status: $status) {
      id
      patientId
      episodeOfCareId
      status
      formData
      createdAt
      updatedAt
      submittedAt
      signedAt
      createdBy
    }
  }
`.loc?.source.body as GeneratedMutation<
  UpdateAccommodationFormStatusMutationVariables,
  {
    updateAccommodationFormStatus: AccommodationForm;
  }
>;

export const useUpdateAccommodationFormStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      variables: UpdateAccommodationFormStatusMutationVariables
    ) => fetchGraphQLClient(updateAccommodationFormStatusMutation, variables),
    onSuccess: (data) => {
      const form = data.data?.updateAccommodationFormStatus;
      if (form) {
        queryClient.invalidateQueries({
          queryKey: ["accommodationForms", form.patientId],
        });
        queryClient.invalidateQueries({
          queryKey: ["accommodationFormsByEpisode", form.episodeOfCareId],
        });
        queryClient.invalidateQueries({
          queryKey: ["accommodationForm", form.id],
        });
      }
    },
  });
};
